class BlipConstants {
    static BUILDER_WORKING_CONFIGURATION_VARIABLES_BUCKET_KEY =
        'blip_portal%3Abuilder_working_configuration';

    static BUILDER_WORKING_GLOBAL_ACTIONS_BUCKET_KEY =
        'blip_portal:builder_working_global_actions';

    static BUILDER_WORKING_FLOW_BUCKET_KEY =
        'blip_portal:builder_working_flow';

    static INSTANCE_NAME = 'portal-cerberus';
}

export default BlipConstants;
